import * as React from 'react';
import { Field, FieldsProps } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl/index';
import { FaCheck, FaWindowClose } from 'react-icons/fa';
import { isRequired } from '../../../../../../util/validators';
import * as Commonmark from 'react-commonmark';
import FieldFormError from '../../../../../../components/FieldFormError';

interface IQuestionProps {
  fields: FieldsProps<any>;
  questions: any;
}

class Questions extends React.Component<IQuestionProps> {
  public componentWillMount() {
    const { fields, questions, meta } = this.props;

    if (fields.length === 0) {
      questions.map((question) => fields.push({ ...question, answer: undefined }));
    }
  }

  private renderMedicalQuestion = (item, key) => {
    return (
      <div className="radio-question" key={key}>
        <Row>
          <Col md={12} lg={8}>
            <Commonmark source={item.content} />
          </Col>
          <Col md={12} lg={4}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              type="radio"
              format={null}
              value={false}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[
                isRequired,
              ]}
              omitError={true}
            >
              <div className="medical-btn">
                <FaWindowClose /> No
              </div>
            </Field>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              type="radio"
              value={true}
              format={null}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[
                isRequired,
              ]}
              omitError={true}
            >
              <div className="medical-btn">
                <FaCheck /> Yes
              </div>
            </Field>

            <Field
              name={`medicalDeclaration[${key}].answer`}
              component={FieldFormError}
              validate={[
                isRequired,
              ]}
           />

          </Col>
        </Row>
      </div>
    );
  }

  private renderMedicalHeader = (item, key) => {
    return (
      <div key={key}>
        <p>
          {item.content}
        </p>
      </div>
    );
  }

  public render() {
    const { fields } = this.props;

    return (
      <div>
        {fields.getAll().map((question, key) => {
          let component;

          if (question.type === 'header') {
            component = this.renderMedicalHeader(question, key);
          }

          if (question.type === 'question') {
            component = this.renderMedicalQuestion(question, key);
          }

          return component;
        })}
      </div>
    );
  }
}

export default Questions;
